module["exports"] = ["GmbH", "AG", "Gruppe", "KG", "GmbH & Co. KG", "UG", "OHG"];